import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyMobilecheck } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button, SelectWithLabelOption } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data4 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import RequesterMultiSelect from "../RequesterMultiSelect";
import { useService } from "../../../context/ServiceContext";


const MobileCheck = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mobileData, setMobileData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [mobNumber, setMobNumber] = useState("");
  const [reqService,setReqService] = useState("");
  const { serviceName } = useService();

  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
const validateForm = (mobNumber, reqService) => {
  const errors = {};

  if (!mobNumber.trim()) {
    errors.mobNumber = "Mobile number is required.";
  } else if (!/^[1-9][0-9]{9}$/.test(mobNumber)) {
    errors.mobNumber = "Mobile number must be 10 digits and not start with 0.";
  }

  //  Check if at least one service selected
  if (!reqService || reqService.length === 0) {
    errors.reqService = "Please select at least one service.";
  }

  return errors;
};

  

  const handleSubmit = async () => {
    console.log("shivam")
    const validationErrors = validateForm(mobNumber, reqService);
    setErrors(validationErrors);

    console.log("error" , errors);
    console.log("validationErrors", validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
  
    try {
      setIsLoading(true);
       console.log("shivam1")
  
      const response = await verifyMobilecheck({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile: mobNumber,
        requested_services: reqService.map((item) => String(item)),
      });
  
      const statusCode = response?.status?.code;
      const statusMessage = response?.status?.message || response?.message;
  
      if (statusCode === 200) {
        const mobileDetails = response?.data;
  
        if (mobileDetails && typeof mobileDetails === "object") {
          setMobileData(mobileDetails);
          showSuccessToast(statusMessage || "Mobile Verified successfully.");
          setErrors({});
        } else {
          showErrorToast("Mobile details are missing or in an unexpected format.");
        }
      } 
      else {
        // In all other error cases, show the message
        const errorMessage = response?.message || response?.data?.message || statusMessage || `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
  
    } catch (error) {
      console.error("Verify Mobile Error:", error);
      showErrorToast("Failed to verify mobile details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        
        
        <InputWithLabel
          type="text"
          label="Mobile Number"
          placeholder="Enter Mobile No"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="mobile_number"
          id="mobile_number"
          required={true}
          value={mobNumber}
          onChange={(e) => setMobNumber(e.target.value)}
          error={errors.mobNumber}
        />
     
<RequesterMultiSelect
  label="Requester Name"
  selectedValues={reqService}
  setSelectedValues={setReqService}
     error={errors.reqService}
/>

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyMob"
            name="verifyMob"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

      {mobileData && Object.keys(mobileData).length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4">


<div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-96">
  <h2 className="text-lg font-semibold text-yellow-800 mb-3">Raw Response (JSON)</h2>
  <pre className="text-sm bg-gray-100 p-2 rounded-md">
    {JSON.stringify(mobileData, null, 2)}
  </pre>
</div>

{/* Second Half - Mobile Details */}
<div className="bg-white border border-green-300 rounded-md shadow-lg p-4 mt-4">
  <h2 className="text-lg font-semibold text-green-800 mb-3">Details</h2>

  {mobileData ? (
    <div className="text-gray-800 text-sm">
      <p>
        <strong>Message:</strong> {mobileData.message || "-"}
      </p>
      <p>
        <strong>Status:</strong> {mobileData.status || "-"}
      </p>
      <p>
        <strong>Mobile:</strong> {mobileData.mobile || "-"}
      </p>
      <p>
        <strong>Client Ref No:</strong> {mobileData.client_ref_num || "-"}
      </p>
      <p>
        <strong>Request ID:</strong> {mobileData.request_id || "-"}
      </p>

      {/* Dynamic Model Summary */}
      {mobileData.model?.summary && (
        <div className="mt-3">
          <h3 className="font-semibold text-green-700 mb-2">Requested Services</h3>
          <ul className="list-disc list-inside">
            {Object.entries(mobileData.model.summary).map(([key, value]) => (
              <li key={key}>
                <strong>{key}:</strong> {value}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <p className="text-gray-500 italic">No data available.</p>
  )}
</div>


  </div>
)}




    </>
  );
};

export default MobileCheck;
